import { render } from "./BusinessTypes.vue?vue&type=template&id=1c8a3de4&scoped=true"
import script from "./BusinessTypes.vue?vue&type=script&lang=js"
export * from "./BusinessTypes.vue?vue&type=script&lang=js"

import "./BusinessTypes.vue?vue&type=style&index=0&id=1c8a3de4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8a3de4"]])

export default __exports__